export default {
  administrate: "Administrate",
  analytics: "Analytics",
  areas: "Areas",
  attachments: "Attachments",
  audit: "Audit",
  change_requests: "Change Requests",
  error: "Error",
  home: "Home",
  identify: "Identify",
  issues: "Issues",
  items: "Items",
  layouts: "Layouts",
  locations: "Locations",
  models: "Models",
  more: "More",
  notifications: "Notifications",
  performed_work: "Performed Work",
  settings: "Settings",
  to_do: "To-Do",
  work_domains: "Work Domains",
  work_orders: "Work Orders",
  workspaces: "Workspaces",
  zones: "Zones",
  group_name_work_related: "Work-related",
  group_name_registry_entities: "Registry entities",
  group_name_arrangement: "Arrangement",
  group_name_admin: "Admin",
}
